import React, {useRef, useEffect, useState} from 'react';
import { getCookie } from "../utils/cookies";

export const useIsMount = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};

export const useLanguage = (
    predefinedLanguage,
    cookieName,
    defaultLanguage
) => {
    const [language, setLanguage] = useState("");

    const cookieValue = getCookie(cookieName)

    useEffect(()=>{
        // workaround for instantly language change, when AMK is integrated in eservice-core.
        document.addEventListener('lvlv.current_language_changed', (data) => {
            setLanguage(data.detail.lang)
        });
    },[])

    useEffect(() => {
        if (predefinedLanguage === null) {
            const langCookieValue = cookieValue;

            if (langCookieValue !== null) {
                setLanguage(langCookieValue);
            } else {
                setLanguage(defaultLanguage)
            }
        } else {
            setLanguage(predefinedLanguage)
        }
    },[cookieValue, predefinedLanguage])

    return [language, setLanguage, predefinedLanguage]

}